import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import { ROOT_GLOBAL } from "../../../../global/root";
import { LocalStorage } from "../../../../models/LocalStorage";
import { Search } from "../../../../models/Search";
import { SearchProduct } from "../../../../models/SearchProduct";

import { getPriceText } from "../../../../utils/currency";
import { MINI_APP } from "../../../../utils/miniApp";
import { nameAndIdToUrl } from "../../../../utils/slug";
import { urlFullFill } from "../../../../utils/url";
import Env from "../../../../environments";

class SearchProductItem extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    product = new SearchProduct(),
    productsCompare = [],
    redirectDetail = false,
    isLoading,
    source = Search.SOURCE.ORGANIC,
    isPrepend = false,
  } = {}) {
    let checkoutPrice = product.checkoutPrice && product.checkoutCur ? getPriceText(product.checkoutPrice, product.checkoutCur) : "";
    let unitPrice = product.unitPrice && product.unitCur ? getPriceText(product.unitPrice, product.unitCur) : "";
    super(arguments[0], parent, id, {
      class: classNames("SearchProductItem", {
        "is-loading": isLoading,
      }),
      url: getLinkProductDetail(product, source),
      name: product.meta?.title || "",
      description: "",
      image: optimizeImage(product.meta?.image || (LocalStorage.getLanguage() === "vi" ? require("../../../../assets/images/checkout/pimg_default_vi.jpg") : require("../../../../assets/images/checkout/pimg_default_en.jpg"))),
      // storeUrl: product.site?.domain ? "https://www.google.com/s2/favicons?sz=32&domain=" + product.site?.domain : "",
      storeName: product.site?.name || "",
      price: checkoutPrice || $.i18n("productDetail_priceUpdating"),
      sitePrice: unitPrice,
      dataUnitPrice: product.unitPrice,
      classSitePrice: product.unitPrice && product.unitCur ? "" : " hide",
      buttonName: product.button_name || "",
      buttonNameI18n: !product.button_name ? "searchProduct_view" : ""
    }, true, defaultLoading);
    this.isLoading = isLoading;
    this.product = product;
    /** @type {[SearchProduct]} */
    this.productsCompare = productsCompare;
    this.redirectDetail = redirectDetail;
    this.source = source;
    this.isPrepend = isPrepend;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "SearchProductItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.isLoading) {
      $(".item-product", this.element).addClass("animated-background-dark");
      return;
    }
    $("a", this.element).on("click", (e) => {
      let url = getLinkProductDetail(this.product, this.source);
      if (LocalStorage.isMiniApp()) {
        e && e.preventDefault && e.preventDefault();
        MINI_APP.openPage({ url: urlFullFill(url) });
        return;
      }
      if (this.redirectDetail) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    })
  }

  getId() {
    return this.product.pid || this.product.id;
  }

  getUnitPrice() {
    return $(".site-price .price", this.element).attr("data-price");
  }

  setUnitPrice(price, currency, isCheck = false) {
    if (isCheck && this.getUnitPrice()) {
      return;
    }
    $(".site-price .price", this.element).html(price && currency ? getPriceText(price, currency) : "");
    price && currency ? $(".site-price", this.element).removeClass("hide") : $(".site-price", this.element).removeClass("hide");
  }

  getCheckoutPrice() {
    return $(".my-price .price", this.element).attr("data-price");
  }

  setProductPrice(price, currency, isCheck = false) {
    let hasPrice = this.getCheckoutPrice();
    if (isCheck && hasPrice) {
      return;
    }

    $(".my-price .price", this.element).html(price && currency ? getPriceText(price, currency) : $.i18n("productDetail_priceUpdating"));
  }

  parentAppend() {
    this.isPrepend ? this.parent.prepend(this.element) : this.parent.append(this.element);
  }
}
/** @param {SearchProduct} product */
function getLinkProductDetail(product, source) {
  let url = ROOT_GLOBAL.PRODUCT_DETAIL + (product.slug ? `${product.slug}-p${product.id}.html` : nameAndIdToUrl(product.id, product.meta?.title)) + "?dc_source=" + source;
  if (product.pid && product.id !== product.pid) {
    url += "&pid=" + product.pid;
  }
  return url;
}


function optimizeImage(image = "") {
  if (!image) return image;

  if (image.includes(Env.DUTY_CAST_IMGFOE_URL)) {
    image = `${image}${image.indexOf('?') !== -1 ? '&' : '?'}max-w=600`
  }

  return CSS.escape(image);
}

export default SearchProductItem;